export default __webpack_public_path__ + "static/media/Background1.b350b969.png";